module.exports = __webpack_public_path__ + "img/general-aggression.adcbc176.svg";